import { useEffect, useState } from "react";

const useTimer = (startTime) => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!startTime) {
      setElapsed(0);
      return undefined;
    }
    const interval = setInterval(() => setElapsed(Date.now() - startTime), 50);
    return () => clearInterval(interval);
  }, [startTime]);

  return elapsed;
};

export default useTimer;
